<template>
  <component
    :is="component"
    v-bind="linkProps"
    data-slot="arrow-link"
    :aria-label="label"
    class="glass-button inline-flex size-8 shrink-0 items-center justify-center rounded-full text-primary"
    @click="(event) => $emit('click', event)"
  >
    <chevron-right-icon class="size-4" />
  </component>
</template>

<script>
import { ChevronRight } from '@lucide/vue';

/** Round "go to" arrow: an internal or external link, or a button without `to`. */
export default {
  name: 'ArrowLink',
  components: {
    ChevronRightIcon: ChevronRight,
  },
  props: {
    to: {
      type: [ String, null ],
      required: false,
      default: () => null,
    },
    label: {
      type: String,
      required: true,
    },
  },
  emits: [ 'click' ],
  computed: {
    isExternal() {
      return !!this.to && this.to.startsWith('http');
    },
    component() {
      if (!this.to) {
        return 'button';
      }

      return this.isExternal ? 'a' : 'router-link';
    },
    linkProps() {
      if (!this.to) {
        return { type: 'button' };
      }

      return this.isExternal ? { href: this.to, target: '_blank' } : { to: this.to };
    },
  },
};
</script>
